module.exports = __webpack_public_path__ + "img/menu.77186a11.svg";